/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Footer_Links_AriaInputs */

const en_landing_footer_links_aria = /** @type {(inputs: Landing_Footer_Links_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Footer links`)
};

const de_landing_footer_links_aria = /** @type {(inputs: Landing_Footer_Links_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Footer-Links`)
};

const fr_landing_footer_links_aria = /** @type {(inputs: Landing_Footer_Links_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liens du pied de page`)
};

const es_landing_footer_links_aria = /** @type {(inputs: Landing_Footer_Links_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enlaces del pie de página`)
};

const it_landing_footer_links_aria = /** @type {(inputs: Landing_Footer_Links_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link del footer`)
};

const nl_landing_footer_links_aria = /** @type {(inputs: Landing_Footer_Links_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Footerlinks`)
};

const pl_landing_footer_links_aria = /** @type {(inputs: Landing_Footer_Links_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linki w stopce`)
};

const fi_landing_footer_links_aria = /** @type {(inputs: Landing_Footer_Links_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alatunnisteen linkit`)
};

const da_landing_footer_links_aria = /** @type {(inputs: Landing_Footer_Links_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sidefodlinks`)
};

const sv_landing_footer_links_aria = /** @type {(inputs: Landing_Footer_Links_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sidfotslänkar`)
};

/**
* | output |
* | --- |
* | "Footer links" |
*
* @param {Landing_Footer_Links_AriaInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_footer_links_aria = /** @type {((inputs?: Landing_Footer_Links_AriaInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Footer_Links_AriaInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_footer_links_aria(inputs)
	if (locale === "fr") return fr_landing_footer_links_aria(inputs)
	if (locale === "es") return es_landing_footer_links_aria(inputs)
	if (locale === "it") return it_landing_footer_links_aria(inputs)
	if (locale === "nl") return nl_landing_footer_links_aria(inputs)
	if (locale === "pl") return pl_landing_footer_links_aria(inputs)
	if (locale === "fi") return fi_landing_footer_links_aria(inputs)
	if (locale === "da") return da_landing_footer_links_aria(inputs)
	if (locale === "sv") return sv_landing_footer_links_aria(inputs)
	return en_landing_footer_links_aria(inputs)
});